import Service from '../Service'
import {http} from '../config'

export default class FornecedorService extends Service{

    constructor(){
        super('fornecedor');
    }

    AutoComplete(q) {
        return http.get(this._nomeControle + "/AutoComplete?q=" + q);
    }

    VerificarExistente(cpfCnpj) {
        return http.get(this._nomeControle + "/VerificarExistente", {
            params: {
                cpfCnpj
            }
        });
    }
      
  }